import { FC, useEffect } from 'react';
import { FooterContainer } from '../modules/footer/footer.container';
import { NewsFeaturedListContainer } from '../modules/news-featured-list/news-featured-list.container';

export const NewsFeaturedList: FC = () => {
  useEffect(() => {
    if (typeof window !== 'undefined' && window.scrollY !== 0) {
      window.scrollTo(0, 0);
    }
  }, []);

  return (
    <>
      <div>
        <NewsFeaturedListContainer />
      </div>
      <FooterContainer />
    </>
  );
};
